var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h2',{staticClass:"title text-danger"},[_vm._v("Página não permitida")]),_c('h2',{staticClass:"title"},[_vm._v("A página que tentou acessar não é permitida para o seu usuário.")])])])])
}]

export { render, staticRenderFns }